<!-- eslint-disable max-len -->
<template>
  <li
    tabindex="-1"
    class="selected-treatments__card"
    :class="{'has-error': hasError}"
    :data-uuid="treatment.uuid"
  >
    <div class="selected-treatments__card-body">
      <div class="selected-treatments__card-order">
        {{ treatment.order }}
      </div>
      <div class="selected-treatments__card-heading">
        <h3 class="selected-treatments__card-title">
          {{ treatment.sitecoreTreatmentDetails.title }}
        </h3>
        <p class="selected-treatments__card-category">
          {{ treatment.treatmentCategory.title }}
        </p>
      </div>
      <div class="selected-treatments__card-duration">
        {{ treatment.selectedTimeSlot.duration }}
      </div>
      <div class="selected-treatments__card-price">
        {{ getTreatmentPriceFormatted({ treatment: treatment.selectedTimeSlot, checkTaxes: true }) }}
      </div>
      <div class="selected-treatments__card-therapist input dropdown">
        <select
          id="preferredGender"
          v-model="preferredGenderSelected"
          name="preferredGender"
          data-field-type="DropdownList"
          class="selected-treatments__card-select"
        >
          <option
            v-for="gender in preferredGenderOptions"
            :key="gender.value"
            :value="gender.value"
          >
            {{ gender.label }}
          </option>
        </select>
        <label
          for="preferredGender"
          class="floating select-label"
        >
          {{ tc('spaSoft.step1.selectedTreatments.preferedTherapistGenderLabel') }}

        </label>
      </div>
    </div>
    <TreatmentAddOnsList
      v-if="treatmentAddOns.length"
      :treatment-add-ons="treatmentAddOns"
    />
    <div class="selected-treatments__card-controls">
      <button
        v-if="check.isLgAndDown"
        type="button"
        class="selected-treatments__card-controls-close"
        :aria-label="tc('spaSoft.step1.selectedTreatments.ariaLabelRemoveTreatment', { treatmentTitle: treatment.sitecoreTreatmentDetails.title, guestNumber: Number(currentGuestNumber) + 1 })"
        @click="handleRemoveClick"
      >
        <span class="icon-close" />
      </button>
      <div class="selected-treatments__card-controls-arrows">
        <button
          type="button"
          class="selected-treatments__card-controls-arrows-up"
          :class="{disabled: !canMoveUp(treatment.order)}"
          :disabled="!canMoveUp(treatment.order)"
          :aria-label="tc('spaSoft.step1.selectedTreatments.ariaLabelMoveTreatmentUp', { treatmentTitle: treatment.sitecoreTreatmentDetails.title })"
          @click="changeTreatmentOrder(treatment.uuid, 'up')"
        >
          <span class="icon-arrow-up-black" />
        </button>
        <button
          type="button"
          class="selected-treatments__card-controls-arrows-down"
          :class="{disabled: !canMoveDown(treatment.order)}"
          :disabled="!canMoveDown(treatment.order)"
          :aria-label="tc('spaSoft.step1.selectedTreatments.ariaLabelMoveTreatmentDown', { treatmentTitle: treatment.sitecoreTreatmentDetails.title })"
          @click="changeTreatmentOrder(treatment.uuid, 'down')"
        >
          <span class="icon-arrow-down-black" />
        </button>
      </div>
      <button
        v-if="check.isLgAndUp"
        type="button"
        class="selected-treatments__card-controls-close"
        :aria-label="tc('spaSoft.step1.selectedTreatments.ariaLabelRemoveTreatment', { treatmentTitle: treatment.sitecoreTreatmentDetails.title, guestNumber: Number(currentGuestNumber) + 1 })"
        @click="handleRemoveClick"
      >
        <span class="icon-close" />
      </button>
    </div>
  </li>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Tracking from '@mixins/tracking'
  import TreatmentAddOnsList from './treatment-add-ons-list.vue'

  export default {
    name: 'SelectedTreatmentCard',
    components: {
      TreatmentAddOnsList
    },
    mixins: [Tracking],
    inject: ['currentGuestNumber'],
    props: {
      treatment: {
        type: Object,
        required: true,
        default: () => ({})
      },
    },
    data() {
      return {
        treatmentAddOns: [],
      }
    },
    computed: {
      ...mapState('spaSoft', ['genderOptions', 'itineraryErrors', 'propertyData']),
      ...mapState('responsive', ['check']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('spaSoft', ['guestsSelectedData', 'getTreatmentPriceFormatted', 'getTotalCost']),
      ...mapGetters('currency', ['getDisplayPrice', 'orSelected']),

      hasError() {
        return this.itineraryErrors?.type === 'missingTreatments' && this.itineraryErrors?.data[this.currentGuestNumber]?.includes(this.treatment?.selectedTimeSlot?.spaSoftId)
      },
      currentGuestData() {
        return this.guestsSelectedData[this.currentGuestNumber]
      },
      preferredGenderOptions() {
        const allOptions = this.genderOptions || []

        const filteredOptions = allOptions.filter((_, index) => index === 0)

        if (this.treatment?.selectedTimeSlot?.apiTreatmentDetails?.hasMale) {
          const maleOption = allOptions.find((option, index) => index === 1)
          if (maleOption) {
            filteredOptions.push(maleOption)
          }
        }

        if (this.treatment?.selectedTimeSlot?.apiTreatmentDetails?.hasFemale) {
          const femaleOption = allOptions.find((_, index) => index === 2)
          if (femaleOption) {
            filteredOptions.push(femaleOption)
          }
        }

        return filteredOptions
      },
      preferredGenderSelected: {
        get() {
          return this.treatment.selectedTimeSlot.preferredGender
        },
        set(gender) {
          this.updatePreferredGender({
            guest: this.currentGuestNumber,
            uuid: this.treatment.uuid,
            gender
          })
        }
      }
    },
    methods: {
      ...mapActions('spaSoft', ['moveTreatment', 'removeTreatment', 'updatePreferredGender', 'trackSpaViewCart']),
      changeTreatmentOrder(uuid, direction) {
        this.moveTreatment({
          guest: this.currentGuestNumber,
          uuid,
          direction
        })

        this.$nextTick(() => {
          document.querySelector(`.selected-treatments__list .selected-treatments__card[data-uuid="${this.treatment.uuid}"]`).focus()
        })
      },
      canMoveUp(order) {
        return order > 1
      },
      canMoveDown(order) {
        return order < this.currentGuestData.selectedTreatments.length
      },
      handleRemoveClick() {
        this.removeTreatment({ guest: this.currentGuestNumber, uuid: this.treatment.uuid })
        this.trackTreatmentRemoved()

        this.$nextTick(() => {
          document.querySelector(`#guest-${this.currentGuestNumber}-treatment-category`).focus()
        })
      },
      trackTreatmentRemoved() {
        this.$track(this.getTrackingData('spaSoft', null, {
          event: 'spaCartUpdate_Remove',
          stepNumber: 1.6,
          cart: {
            numberOfGuests: this.numberOfGuests,
            cartTotalPrice: this.getTotalCost(),
            currency: this.orSelected(this.propertyData?.currency?.isoCode),
            products: [
              {
                guestNumber: Number(this.currentGuestNumber) + 1,
                productType: 'Treatment',
                treatmentName: this.treatment?.sitecoreTreatmentDetails?.title,
                treatmentType: this.treatment?.treatmentCategory?.title,
                duration: this.treatment?.selectedTimeSlot?.duration,
                price: this.getDisplayPrice({
                  price: this.treatment?.selectedTimeSlot?.apiTreatmentDetails?.price?.totalCalculated,
                  fromCurrency: this.propertyData?.currency?.isoCode,
                  toCurrency: this.orSelected(this.propertyData?.currency?.isoCode),
                  noSymbol: true
                }),
                currency: this.orSelected(this.propertyData?.currency?.isoCode),
                listPosition: this.treatment?.order
              }
            ]
          }
        }))
        this.$nextTick(() => {
          this.trackSpaViewCart()
        })
      },
    },
  }
</script>
